import * as $ from 'jquery';
import { rf_color } from '../tabs/legacy/rf/rf-utils';
import { applyFiletransferUpdate } from '../redux/devices/items/actions';
import { prepare_boiler_models } from '../redux/boiler-models/action';
import { event_array_to_object } from 'shared/api/comet/utils';
import { Capability } from 'console/device/device-capability';
export const AutoIgnitionState = {
    engine: 'engine',
    webasto: 'webasto',
    enabled: 'enabled',
    disabled: 'disabled',
    'webasto-confirmed': 'webasto-confirmed',
    enabling: 'enabling',
    delay: 'delay',
};
export const TemperatureConf = {
    engine: 'engine',
    cabin: 'cabin',
    outside: 'outside',
    none: 'none',
};
export class LegacyDevice {
    _ui;
    _gps;
    _ignore_updates;
    _cometListeners;
    _id;
    _serial;
    _name;
    _color;
    _timezone;
    _is_active;
    _hardware_type;
    _device_type;
    _capabilities;
    _firmware_version;
    _online;
    _temperature_conf;
    _temperature;
    _gps_state;
    _gsm_state;
    _balance;
    _auto_ignition;
    _auto_ignition_timeout;
    _voltage;
    _power_source;
    _current_ecu_errors;
    _saved_ecu_errors;
    _suggest_firmware_upgrade;
    _guard_state;
    _filetransfers;
    _just_installed_firmware;
    _fuel_consumption;
    _trusted_phones;
    _accel_params;
    _auto_ignition_duration;
    _auto_ignition_params;
    _auto_ignition_schedule;
    _last_receive_time_relative;
    _last_connect_time;
    _gps_relevance_relative;
    _gps_relevance_absolute;
    _doors;
    _door_1;
    _door_2;
    _door_3;
    _door_4;
    _hood_trunk;
    _hood;
    _trunk;
    _engine_state;
    _engine_block;
    _siren;
    _webasto;
    _notifications;
    _server_notifications;
    _autoguard;
    _radiosilence;
    _radiosilence_planned;
    _thermometers;
    _thermometers_reset_in_progress;
    _tempschedule;
    _tempschedule_multi;
    _thermostat_mode;
    _thermostat_mode_multi;
    _thermostat_gate;
    _thermostat_gate_multi;
    _thermostat_gate_available;
    _thermostat_mode_temps;
    _thermostat_mode_temps_multi;
    _temperature_alarm;
    _thermostat_ext_mode;
    _thermostat_ext_modes_config;
    _thermostat_ext_modes_advanced;
    _thermostat_target_temps;
    _thermostat_zones_settings;
    _ot_zones_count;
    _thermostat_temps_limits;
    _notes;
    _thermostat_hysteresis;
    _thermostat_error_input_polarity;
    _camera_available;
    _camera_count;
    _tracker_mode;
    _thermostat_inputconfig;
    _thermostat_enable_guard;
    _thermostat_relay_mode;
    _ztc110_inputconfig;
    _ztc110_guard_polarity;
    _zta110_inputconfig;
    _zta110_outputconfig;
    _last_guard_event;
    _last_boiler_state;
    _webasto_timeout;
    _thermostat_enabled;
    _ot_enabled;
    _ot_mode;
    _ot_save_params; //для старых приборов параметры АЦШ, которые отслеживаем
    _ot_config;
    _ot_show_dhw_control;
    _ot_min_wp;
    _ot_max_ml;
    _ot_min_setpoint;
    _ot_max_setpoint;
    _ot_dhw_setpoint;
    _ot_boiler_type;
    _ot_gate_enabled;
    _rf_status;
    _tempstep;
    ___temporary_thermometer_names;
    _wifi_credentials;
    _ecu_diagnostics_enabled;
    _ecu_diagnostics_active;
    _battery_percent;
    _voicesiren_soundpack;
    _siren_loudness;
    _handsfree;
    _ztcconfig_autostart;
    _ztcconfig_locking;
    _ztcconfig_battery;
    _ztcconfig_siren;
    _ztc_savestate;
    _gsm_roaming;
    _service_password_set;
    _boiler_info;
    _pza;
    _pza_max_delta;
    _boiler_delay;
    _user_id;
    _owner_username;
    _access;
    _l1000_config;
    _custom_controls;
    _custom_controls_state;
    _custom_controls_schedule;
    _debug_text_messages_regexp;
    _gtw_boiler_version;
    _gtw_mode;
    _gtw_heat;
    _gtw_service_mode;
    _gtw_fail;
    _gtw_fail_countdown;
    _gtw_ten_count;
    _gtw_ten_max;
    _gtw_sensors_valid;
    _gtw_t_air_int_sensor;
    _gtw_t_air_ext_sensor;
    _gtw_t_water_sensor;
    _gtw_t_water;
    _gtw_t_air;
    _gtw_t_air_comfort;
    _gtw_t_air_econom;
    _gtw_t_air_pza;
    _gtw_t_water_set_disp;
    _gtw_t_air_set_disp;
    _gtw_p_water;
    _gtw_thermostat_air;
    _gtw_thermostat_gvs;
    _gtw_time;
    _gtw_temporary_end;
    _gtw_nominal_power;
    _gtw_interval_s_on;
    _gtw_interval_s_off;
    _gtw_interval_m;
    _gtw_workday_schedule;
    _gtw_weekend_schedule;
    _gtw_ten_schedule;
    _gtw_gvs;
    _gtw_thermostat_set;
    _gtw_rele_max;
    _gtw_t_gvs;
    _gtw_t_water_max;
    _gtw_interval_g_on;
    _gtw_interval_g_off;
    _gtw_t_water_floor_set;
    _graphs_config;
    _global_freeze_state;
    _elinje_state;
    _autoscan_settings;
    _sx_downloading_config;
    _sx_uploading_config;
    _thermostat_service_password;
    _stationary_location;
    _use_internet_weather_for_pza;
    _internet_weather;
    _z3k_config;
    _sim_in_device;
    _cams;
    _cams_show;
    _maintenances;
    _show_heating_tab;
    _called_from_update;
    _thermrestimer;
    _auto_ignition_timer;
    _access_timeouts;
    _pending_settings_request_code;
    _pending_settings;
    $listeners;
    constructor(_ui, options) {
        // Initializing properties with non-atomic types
        this._ui = _ui;
        this._gps = [];
        this._filetransfers = [];
        this._trusted_phones = [];
        this._ignore_updates = {};
        // ID needed for comet listeners below
        this.id(options.id);
        const on_event = (legacy_event) => {
            switch (legacy_event.event_name) {
                case 'CurrentECUErrors':
                case 'AS_CUR_ERR':
                    this.current_ecu_errors(legacy_event.current_ecu_errors);
                    break;
                case 'SavedECUErrors':
                case 'AS_SAV_ERR':
                    this.saved_ecu_errors(legacy_event.saved_ecu_errors);
                    break;
                case 'ThermometerUpdate':
                    this.reload_thermometers();
                    break;
            }
        };
        this._cometListeners = [
            {
                event: 'io_value_changed',
                condition: {
                    device_id: this.id(),
                },
                callback: (msg) => {
                    const name = msg.port.name.replace(/-/g, '_');
                    return this.set(name, msg.port.value);
                },
            },
            {
                event: 'updated',
                condition: {
                    device_id: this.id(),
                },
                callback: (msg) => {
                    if (msg.request_code) {
                        for (const name of Object.keys(this._ignore_updates || {})) {
                            const code = this._ignore_updates[name];
                            if (msg.request_code < code)
                                delete msg[name];
                        }
                    }
                    this.set(msg);
                    if (msg.pending_settings != null)
                        this.has_pending_settings(msg.pending_settings, msg.request_code);
                },
            },
            {
                event: 'io_ports',
                callback: (msg) => {
                    if (msg.ports[this._id]) {
                        const state = msg.ports[this._id];
                        for (const name of Object.keys(state || {})) {
                            const portstate = state[name];
                            this.set(name.replace(/-/g, '_'), portstate.value);
                        }
                    }
                },
            },
            // {
            //     event: 'new_gps',
            //     condition: {
            //         device_id: this.id(),
            //     },
            //     callback: (msg) => {
            //         this.newGPS({
            //             time: new Date(msg.time * 1000),
            //             loc: [msg.GPS[0], msg.GPS[1]],
            //             speed: msg.speed,
            //             prov: msg.provider,
            //             single: msg.single,
            //
            //             hdop: msg.hdop,
            //             satellites: msg.satellites,
            //             altitude: msg.altitude,
            //             avg_va: msg.avg_va,
            //         });
            //     },
            // },
            // {
            //     event: 'new_gps_relevance',
            //     condition: {
            //         device_id: this.id()
            //     },
            //     callback: msg => {
            //         this.gps_relevance_relative(msg.current_time - msg.gps_relevance);
            //     }
            // },
            {
                event: 'new_data',
                condition: {
                    device_id: this.id(),
                },
                callback: this.notifier('new_data'),
            },
            {
                event: 'new_data',
                condition: {
                    device_id: this.id(),
                },
                callback: (msg) => {
                    if (!msg.events)
                        return;
                    for (const event of msg.events)
                        on_event(event_array_to_object(event, this.id()));
                },
            },
            {
                event: 'online',
                condition: {
                    device_id: this.id(),
                },
                callback: (msg) => {
                    this.online(true);
                },
            },
            {
                event: 'offline',
                condition: {
                    device_id: this.id(),
                },
                callback: (msg) => {
                    this.online(false);
                },
            },
            {
                event: 'filetransfer_update',
                condition: {
                    device_id: this.id(),
                },
                callback: (msg) => {
                    this.filetransfer_update(msg.transfer);
                },
            },
            {
                event: 'new_temperature',
                condition: {
                    device_id: this.id(),
                },
                callback: (msg) => {
                    const thermometers = this.thermometers();
                    if (thermometers == null)
                        return;
                    const thermometer_by_id = {};
                    for (const therm of thermometers) {
                        thermometer_by_id[therm.uuid] = therm;
                    }
                    for (const therm_id of Object.keys(msg.temperature || {})) {
                        const msgtherm = msg.temperature[therm_id];
                        const thermometer = thermometer_by_id[therm_id];
                        if (thermometer == null) {
                            continue;
                        }
                        thermometer.last_state = msgtherm.state;
                        thermometer.last_value = msgtherm.value;
                        thermometer.last_value_time = msg.time;
                    }
                    this.notify('thermometers');
                    this.notify('new_temperature', [msg]);
                },
            },
            // {
            //     event: 'new_thermostat_work',
            //     condition: {
            //         device_id: this.id()
            //     },
            //     callback: msg => {
            //         this.notify('new_thermostat_work', [ msg ]);
            //     }
            // },
            // {
            //     event: 'new_gtw_report',
            //     condition: {
            //         device_id: this.id()
            //     },
            //     callback: msg => {
            //         this.notify('new_gtw_report', [msg]);
            //     }
            // },
            // {
            //     event: 'new_ztc_state',
            //     condition: {
            //         device_id: this.id()
            //     },
            //     callback: msg => {
            //         this.notify('new_ztc_state', [msg]);
            //     }
            // },
            {
                event: 'reset_thermometers_response',
                condition: {
                    device_id: this.id(),
                    ok: false,
                },
                callback: () => {
                    this.thermometers_reset_in_progress(false);
                    this.reload_thermometers();
                },
            },
            {
                event: 'camerashot_progress',
                condition: {
                    device_id: this.id(),
                },
                callback: (msg) => {
                    this.notify('camerashot_progress', [msg]);
                },
            },
            {
                event: 'camerashot_ready',
                condition: {
                    device_id: this.id(),
                },
                callback: (msg) => {
                    this.notify('camerashot_ready', [msg]);
                },
            },
            {
                event: 'opentherm_diag_value',
                condition: {
                    device_id: this.id(),
                },
                callback: (msg) => {
                    this.notify('opentherm_diag_value', [
                        {
                            param_no: msg.param_no,
                            adapter_no: msg.adapter_no,
                            name: msg.param_name,
                            value: msg.param_value,
                        },
                    ]);
                },
            },
            {
                event: 'request_opentherm_diag_response',
                condition: {
                    device_id: this.id(),
                },
                callback: (msg) => {
                    this.notify('request_opentherm_diag_response', [
                        {
                            ok: msg.ok,
                        },
                    ]);
                },
            },
            {
                event: 'request_opentherm_count_response',
                condition: { device_id: this.id() },
                callback: (msg) => {
                    this.notify('request_opentherm_count_response', [
                        {
                            ok: msg.ok,
                            ids: msg.ids,
                        },
                    ]);
                },
            },
            {
                event: 'new_rf_statuses',
                condition: {
                    device_id: this.id(),
                },
                callback: (msg) => {
                    const rf_status = this.rf_status() || {};
                    for (const serial of Object.keys(msg.rf || {})) {
                        const values = msg.rf[serial];
                        rf_status[serial] = Object.assign({}, rf_status[serial], values);
                    }
                    this.rf_status(rf_status);
                },
            },
            {
                event: 'rf_load_devices_response',
                condition: {
                    device_id: this.id(),
                },
                callback: (msg) => this.rf_status(msg.rf),
            },
            {
                event: 'debug_text_message',
                condition: { device_id: this.id() },
                callback: (msg) => {
                    this.notify('debug_text_message', [msg.text]);
                },
            },
            {
                event: 'sx_download_config_progress',
                condition: { device_id: this.id() },
                callback: (msg) => this.sx_downloading_config(msg.percent),
            },
            {
                event: 'sx_upload_config_progress',
                condition: { device_id: this.id() },
                callback: (msg) => this.sx_uploading_config(msg.percent),
            },
        ];
        this._ui.comet.listenMany(this._cometListeners);
        this._called_from_update = true;
        this.set(options);
        if (options.io != null)
            this.setIOValues(options.io);
        this._called_from_update = false;
    }
    destroy() {
        for (const listener of this._cometListeners) {
            this._ui.comet.unlisten(listener);
        }
        this._clear_access_timeouts();
    }
    // newGPS(gps) {
    //     if (this._gps.length > 1 && gps.time < this._gps[this._gps.length - 1].time)
    //         return;
    //
    //     this._gps.push(gps);
    //     this._gps.sort((a, b) => {
    //         if (a.time < b.time) return +1;
    //         if (a.time > b.time) return -1;
    //         return 0;
    //     });
    //
    //     if (this._gps.length > 50) this._gps.pop();
    //
    //     this.notify('gps', [gps]);
    // },
    // last_gps: (last_gps) ->
    //     @_gps = []
    //     for gps in last_gps ? []
    //         @_gps.push
    //             loc: [gps.x, gps.y]
    //             speed: gps.speed
    //             time: new Date gps.time*1000
    //     this.notify 'gps'
    gps() {
        return this._gps;
    }
    async clearECUErrors(callback) {
        const request_id = +this._ui.comet.generateRandomSerial();
        this._ui.comet.listen({
            once: true,
            event: 'clear_ecu_errors_response',
            condition: {
                request_id,
            },
            callback(msg) {
                callback({
                    ok: msg.ok,
                    error: msg.error,
                });
            },
        });
        try {
            await this._ui.api.clear_ecu_errors({
                device_id: this.id(),
                session_id: this._ui.comet.session_id(),
                request_id,
            });
        }
        catch (error) {
            const { json } = error;
            callback({
                ok: false,
                error: json
                    ? 'Не удалось очистить ошибки ЭБУ'
                    : 'Не удалось отправить запрос',
            });
        }
    }
    // async sendConsoleCommand(cmd, callback) {
    //     const request_id = this._ui.comet.generateRandomSerial();
    //
    //     this._ui.comet.listen({
    //         once: true,
    //         event: 'text_response',
    //         condition: {
    //             request_id
    //         },
    //         callback
    //     });
    //
    //
    //     try {
    //         await this._ui.api.call_v2({
    //             method: 'send_text_to_device',
    //             data: {
    //                 device_id: this.id(),
    //                 text: cmd,
    //                 session_id: this._ui.comet.session_id(),
    //                 request_id
    //             }
    //         });
    //
    //     } catch (error) {
    //         const {json} = error;
    //         callback({
    //             ok: false,
    //             error: (json != null ? json.error_ui : undefined) != null ? (json != null ? json.error_ui : undefined) : 'Не удалось отправить команду на сервер'
    //         });
    //     }
    // },
    // sendSeveralConsoleCommands: function (cmds, callback) {
    //     var serials = $.map(cmds, function (cmd, i) {
    //         var serial = this._ui.comet.generateRandomSerial()
    //         this._ui.comet.listen({
    //             once: true,
    //             event: 'text_response',
    //             condition: { serial: serial },
    //             callback: function (msg) {
    //                 callback(msg, i)
    //             }
    //         })
    //         return serial
    //     })
    //     this._ui.api.call({
    //         method: 'send_several_texts_to_device',
    //         data: {
    //             device_id: this.id(),
    //             texts: cmds,
    //             serials: serials
    //         },
    //         success: function (json) {
    //             if (json.result != 'ok')
    //                 callback({ ok: false, error: json.error })
    //         },
    //         error: function () {
    //             callback({ ok: false, error: 'Не удалось отправить команды на сервер' })
    //         }
    //     })
    // },
    filetransfer_update(transfer) {
        let found = false;
        for (const existing of this._filetransfers) {
            if (existing.id === transfer.id) {
                $.extend(existing, transfer);
                found = true;
                break;
            }
        }
        if (!found)
            this._filetransfers.push(transfer);
        this.notify('filetransfers');
        this._ui.store.dispatch(applyFiletransferUpdate(this.id(), transfer));
    }
    async resetZTCThermometers(callback) {
        this._ui.comet.listen({
            once: true,
            event: 'reset_ztc_thermometers_response',
            condition: {
                device_id: this.id(),
            },
            callback(msg) {
                return callback({ ok: msg.ok });
            },
        });
        try {
            await this._ui.api.reset_ztc_thermometers({
                device_id: this.id(),
            });
        }
        catch (error) {
            callback({ ok: false, error: 'Ошибка связи с сервером' });
        }
    }
    // _resetIOPorts: ->
    //     props = [
    //         'temperature', 'gps_state', 'gsm_state',
    //         'auto_ignition', 'voltage', 'guard_state',
    //         'doors', 'door_1', 'door_2', 'door_3', 'door_4',
    //         'hood', 'trunk', 'hood_trunk',
    //         'engine_state', 'engine_block', 'siren', 'webasto',
    //         # 'camera_available', 'camera_count',
    //         'last_boiler_state'
    //     ]
    //     for name in props
    //         @[name]?(undefined)
    // async requestPortChange(portname, value, type) {
    //     try {
    //         return await this._ui.api.call_v2({
    //             method: 'set_io_port',
    //             data: {
    //                 device_id: this.id(),
    //                 portname,
    //                 type,
    //                 value
    //             }
    //         });
    //
    //     } catch (error) {
    //         const {json} = error;
    //         return $.mui.mui_dialog.errorbox({
    //             title: 'Ошибка',
    //             message: (json != null ? json.error_ui : undefined) != null ? (json != null ? json.error_ui : undefined) : 'Не удалось отправить запрос'
    //         });
    //     }
    // },
    updateSettingsPromise(settings, options) {
        return new Promise((resolve, reject) => {
            this.updateSettings(settings, 
            // @ts-ignore
            ({ ok, ...result }) => (ok ? resolve : reject)(result), options);
        });
    }
    async updateSettings(settings, callback, { obey_only_last_response = false, ignore_server_response = false, authenticator = null, } = {}) {
        settings.device_id = this.id();
        // if (obey_only_last_response)
        // {
        //     var serial = this._ui.comet.generateRandomSerial()
        //     this._ignore_updates[serial] = true
        //     settings._request_code = serial
        // }
        try {
            const json = await this._ui.api.update_device(settings.device_id, settings);
            // Don't update thermometers if resetting is in progress
            if (this.thermometers_reset_in_progress())
                delete json.thermometers;
            if (!ignore_server_response)
                this.set(json);
            if (obey_only_last_response && json._request_time != null)
                for (const propname of Object.keys(settings || {})) {
                    this._ignore_updates[propname] = json._request_time;
                }
            this.has_pending_settings(json.pending_settings, json._request_time);
            callback?.({ ok: true });
        }
        catch (error) {
            const { json } = error;
            let errors;
            switch (typeof json?.error_ui) {
                case 'string':
                    errors = [json.error_ui];
                    break;
                case 'object':
                    errors = json.error_ui;
                    break;
                default:
                    errors = ['Не удалось сохранить параметры'];
            }
            return callback?.({ ok: false, errors, error: json?.error });
        }
    }
    last_firmware() {
        // const last = __guard__(PRELOAD.last_firmwares[this._hardware_type != null ? this._hardware_type.code : undefined], x => x[this._device_type != null ? this._device_type.code : undefined]);
        const last = 
        // @ts-ignore
        PRELOAD.last_firmwares?.[this._hardware_type?.code]?.[this.device_type()?.code];
        const my_rollout_id = parseInt(this.serial().substr(0, 2), 16);
        if (last?.rollout != null &&
            !isNaN(my_rollout_id) &&
            (my_rollout_id / 256) * 100 > last?.rollout)
            return null;
        return last;
    }
    last_firmware_version() {
        return this.last_firmware()?.version;
    }
    // last_firmware_version_human() {
    //     const last = this.last_firmware();
    //     return last != null ? last.version.join(':') : '';
    // },
    human_version() {
        return this._firmware_version != null ? this._firmware_version.join(':') : '';
    }
    has_capability(codename) {
        return this.capabilities().indexOf(codename) !== -1;
    }
    has_all_capabilities(codenames) {
        for (const cap of codenames)
            if (!this.has_capability(cap))
                return false;
        return true;
    }
    has_any_capability(codenames) {
        for (const cap of codenames)
            if (this.has_capability(cap))
                return true;
        return false;
    }
    setIOValues(dict) {
        for (const key of Object.keys(dict || {})) {
            const value = dict[key];
            this.set(key.replace(/-/g, '_'), value);
        }
    }
    // requestRadiosilence(state) {
    //     if (!this.has_access('control')) {
    //         $.mui.mui_dialog.errorbox({
    //             title: 'Нет доступа',
    //             message: 'Вы не можете управлять устройством'
    //         });
    //         return;
    //     }
    //
    //     state = !!state;
    //
    //     this._ui.api.call_v2({
    //         method: 'request_radiosilence',
    //         data: {
    //             device_id: this.id(),
    //             state
    //         }
    //     });
    //
    //     this.radiosilence_planned(state);
    // },
    async loadTelPassword(callback) {
        let json;
        try {
            json = await this._ui.api.load_tel_password(this.id());
        }
        catch (error) {
            const { json } = error;
            callback({
                ok: false,
                error: (json != null ? json.error_ui : undefined) != null
                    ? json != null
                        ? json.error_ui
                        : undefined
                    : 'Ошибка связи с сервером',
            });
            return;
        }
        return callback({
            ok: true,
            tel_password: json.tel_password,
        });
    }
    thermometerById(thermometer_id) {
        if (this._thermometers == null)
            return null;
        for (const thermometer of this._thermometers)
            if (thermometer.uuid === thermometer_id)
                return thermometer;
        return null;
    }
    // change_thermometers: function (dict) {
    //     for (var therm_id in dict)
    //     {
    //         var therm = this.thermometerById(therm_id)
    //         for (var key in dict[therm_id])
    //         {
    //             if (key == 'name')
    //                 therm.name = dict[therm_id][key]
    //         }
    //     }
    //     this._ui.api.call({
    //         method: 'change_thermometers',
    //         data: {
    //             device_id: this.id(),
    //             thermometers: dict
    //         }
    //     })
    // },
    reset_thermometers() {
        const thermometers = this.thermometers();
        if (thermometers != null)
            for (const therm of thermometers)
                therm.is_assigned_to_slot = false;
        this.thermometers_reset_in_progress(true);
        this._ui.api.reset_thermometers({
            device_id: this.id(),
        });
    }
    async reload_thermometers() {
        const json = await this._ui.api.load_thermometers(this.id());
        this.thermometers(json.thermometers);
        this.thermometers_reset_in_progress(false);
    }
    active_thermometers() {
        return (this.thermometers() || []).filter((therm) => therm?.is_assigned_to_slot);
    }
    has_multiple_thermostat_zones() {
        let zone_count = 0;
        for (const zone_no of Object.keys(this.thermostat_target_temps() || {}))
            zone_count++;
        return zone_count > 2;
    }
    control_thermometer_for_zone(zone_no) {
        for (const therm of this.active_thermometers())
            if (therm.is_assigned_to_slot)
                for (const func of therm.functions || [])
                    if (func.f === 'control' && func.zone === zone_no)
                        return therm;
        return null;
    }
    // thermometer_by_serial(serial) { return Device.thermometer_by_serial(this._thermometers, serial); },
    wake_camera(timeout, quality, number) {
        const params = {
            device_id: this.id(),
            timeout,
        };
        if (quality != null)
            params.quality = parseInt(String(quality), 10);
        if (number != null)
            params.number = parseInt(String(number), 10);
        this._ui.api.wake_camera(params);
    }
    // icon() { switch (false) {
    //     case !!this.online(): return 'offline';
    //     case !!this.has_guard(): return 'online';
    //     case this.guard_state() !== 'enabled': return 'guard-on';
    //     default: return 'guard-off';
    // } },
    request_opentherm_diag(adapter_no = 0) {
        this._ui.api.request_opentherm_diag({
            device_id: this.id(),
            adapter_no,
        });
    }
    request_opentherm_count() {
        this._ui.api.request_opentherm_count({ device_id: this.id() });
    }
    async rf_load_devices(callback) {
        let comet_listener = null;
        if (callback != null) {
            comet_listener = {
                once: true,
                event: 'rf_load_devices_response',
                condition: {
                    device_id: this.id(),
                },
                callback,
            };
            // @ts-ignore
            this._ui.comet.listen(comet_listener);
        }
        try {
            await this._ui.api.rf_load_devices({
                device_id: this.id(),
            });
        }
        catch (error) {
            const { json } = error;
            // @ts-ignore
            if (comet_listener != null)
                this._ui.comet.unlisten(comet_listener);
            return callback({
                ok: false,
                error: (json != null ? json.error_ui : undefined) != null
                    ? json != null
                        ? json.error_ui
                        : undefined
                    : 'Не удалось загрузить информацию',
            });
        }
    }
    async rf_delete_device(serial) {
        const comet_listener = {
            once: true,
            event: 'rf_delete_device_response',
            condition: {
                device_id: this.id(),
                ok: true,
            },
            callback: () => {
                const status = this.rf_status();
                if (status) {
                    delete status[serial];
                }
                return this.rf_status(status);
            },
        };
        // @ts-ignore
        this._ui.comet.listen(comet_listener);
        try {
            await this._ui.api.rf_delete_device({
                device_id: this.id(),
                serial,
            });
        }
        catch (error) {
            // @ts-ignore
            this._ui.comet.unlisten(comet_listener);
        }
    }
    async rf_delete_all(callback) {
        let comet_listener = null;
        if (callback != null) {
            comet_listener = {
                once: true,
                event: 'rf_delete_all_response',
                condition: {
                    device_id: this.id(),
                },
                callback: () => {
                    this.rf_status({});
                    return callback();
                },
            };
            // @ts-ignore
            this._ui.comet.listen(comet_listener);
        }
        try {
            await this._ui.api.rf_delete_all({
                device_id: this.id(),
            });
        }
        catch (error) {
            const { json } = error;
            // @ts-ignore
            if (comet_listener != null)
                this._ui.comet.unlisten(comet_listener);
            callback?.({
                ok: false,
                error: json?.error_ui || 'Не удалось отправить запрос',
            });
        }
    }
    async rf_add_devices(callback) {
        let comet_listener = null;
        if (callback != null) {
            comet_listener = {
                once: true,
                event: 'rf_add_devices_response',
                condition: {
                    device_id: this.id(),
                },
                callback,
            };
            // @ts-ignore
            this._ui.comet.listen(comet_listener);
        }
        try {
            await this._ui.api.rf_add_devices({
                device_id: this.id(),
            });
        }
        catch (error) {
            const { json } = error;
            // @ts-ignore
            if (comet_listener != null)
                this._ui.comet.unlisten(comet_listener);
            return callback({
                ok: false,
                error: json?.error_ui || 'Не удалось отправить запрос',
            });
        }
    }
    // filetransfer_percent(type) {
    //     let progress_sum = 0;
    //     let progress_cnt = 0;
    //     for (let ft of this._filetransfers) {
    //         if ((type != null) && (ft.type !== type)) {
    //             continue;
    //         }
    //         if (ft.done) {
    //             continue;
    //         }
    //
    //         progress_sum += ft.progress;
    //         progress_cnt++;
    //     }
    //
    //     return (
    //         progress_cnt > 0 ?
    //             parseInt((progress_sum / progress_cnt) * 100, 10)
    //         :
    //             0
    //     );
    // },
    // filetransfer_in_progress(type) {
    //     for (let ft of this._filetransfers) {
    //         if ((type != null) && (ft.type !== type)) {
    //             continue;
    //         }
    //         if (ft.done) {
    //             continue;
    //         }
    //         return true;
    //     }
    //
    //     return false;
    // },
    async request_config_file(service_password, callback) {
        try {
            const json = await this._ui.api.request_config_file(this.id(), service_password);
            this.filetransfer_update(json.transfer);
            if (callback != null) {
                this._ui.comet.listen({
                    once: true,
                    event: 'filetransfer_update',
                    condition: {
                        device_id: this.id(),
                        transfer: {
                            id: json.transfer.id,
                            done: true,
                        },
                    },
                    callback: (msg) => {
                        let content_id;
                        let config_content_id = null;
                        for (const filename of Object.keys(
                        // @ts-ignore
                        msg.transfer.content_ids || {})) {
                            // @ts-ignore
                            content_id = msg.transfer.content_ids[filename];
                            config_content_id = content_id;
                            break;
                        }
                        if (config_content_id != null) {
                            callback({
                                ok: true,
                                content_id: config_content_id,
                            });
                        }
                        else {
                            callback({
                                ok: false,
                                error: 'filetransfer_failed',
                            });
                        }
                    },
                });
            }
        }
        catch (error) {
            const { json } = error;
            callback?.({
                ok: false,
                error: json?.error || 'Не удалось отправить запрос на сервер',
            });
        }
    }
    // async request_file_download(filename, transfer_type, callback) {
    //     let json;
    //     try {
    //         json = await this._ui.api.call_v2({
    //             method: 'request_file_download',
    //             data: {
    //                 device_id: this.id(),
    //                 filename,
    //                 transfer_type
    //             }
    //         });
    //
    //         this.filetransfer_update(json.transfer);
    //         if (callback != null) {
    //             return this._ui.comet.listen({
    //                 once: true,
    //                 event: 'filetransfer_update',
    //                 condition: {
    //                     device_id: this.id(),
    //                     transfer: {
    //                         id: json.transfer.id,
    //                         done: true
    //                     }
    //                 },
    //                 callback(msg) {
    //                     return callback({
    //                         ok: true,
    //                         content_id: msg.transfer.content_ids[filename]});
    //                 }});
    //         }
    //
    //     } catch (error) {
    //         ({json} = error);
    //         return (typeof callback === 'function' ? callback({
    //             ok: false,
    //             error: (json != null ? json.error : undefined) != null ? (json != null ? json.error : undefined) : 'Не удалось отправить запрос на сервер'
    //         }) : undefined);
    //     }
    // },
    request_sx_config() {
        return new Promise((resolve, reject) => {
            this._ui.comet.listen({
                once: true,
                event: 'sx_download_config_response',
                condition: { device_id: this.id() },
                callback: (msg) => {
                    this.sx_downloading_config(null);
                    // @ts-ignore
                    if (msg.ok)
                        resolve(msg);
                    else
                        reject(msg);
                },
            });
            this.sx_downloading_config(0);
            this._ui.api.sx_download_config(this.id()).then(() => { }, ({ json }) => {
                this.sx_downloading_config(null);
                reject(json);
            });
        });
    }
    upload_sx_config(file, on_progress) {
        return new Promise((resolve, reject) => {
            this._ui.comet.listen({
                once: true,
                event: 'sx_upload_config_response',
                condition: { device_id: this.id() },
                callback: (msg) => {
                    this.sx_uploading_config(null);
                    // @ts-ignore
                    if (msg.ok)
                        resolve(msg);
                    else
                        reject(msg);
                },
            });
            this.sx_uploading_config(0);
            // const data = new FormData();
            //
            // data.append('device_id', String(this.id()));
            // data.append('config_file', file);
            this._ui.api.sx_upload_config(this.id(), file).then(() => { }, ({ json }) => {
                this.sx_uploading_config(null);
                reject(json);
            });
        });
    }
    has_access(permissions, { user_id = null, time = new Date() } = {}) {
        if (user_id == null)
            user_id = this._ui.account.id();
        return LegacyDevice.has_access(user_id != null ? user_id : this._ui.account.id(), {
            user_id: this.user_id(),
            access: this.access(),
            timezone: this.timezone(),
        }, permissions, time);
    }
    _clear_access_timeouts() {
        // for (let t of (this._access_timeouts != null ? this._access_timeouts.timeouts : undefined) != null ? (this._access_timeouts != null ? this._access_timeouts.timeouts : undefined) : []) { clearTimeout(t); }
        // for (let i of (this._access_timeouts != null ? this._access_timeouts.schedule-editor : undefined) != null ? (this._access_timeouts != null ? this._access_timeouts.schedule-editor : undefined) : []) { clearInterval(i); }
        (this._access_timeouts?.timeouts || []).forEach(clearTimeout);
        (this._access_timeouts?.intervals || []).forEach(clearInterval);
        this._access_timeouts = { timeouts: [], intervals: [] };
    }
    _reschedule_access_timeouts() {
        this._clear_access_timeouts();
        const user_id = this._ui.account.id();
        const now = new Date().getTime() / 1e3;
        let has_weekschedule = false;
        for (const acc of this.access() || [])
            if (acc.user_id === user_id) {
                if (acc.until != null && acc.until > now)
                    this._access_timeouts.timeouts.push(setTimeout(this.notifier('access'), (acc.until - now + 1) * 1e3));
                if (!has_weekschedule)
                    has_weekschedule = acc.weekschedule != null;
            }
        if (has_weekschedule) {
            const interval = 60 * 60;
            const ms_to_next_hour = interval * 1e3 - (new Date().getTime() % (interval * 1e3));
            this._access_timeouts.timeouts.push(setTimeout(() => {
                this._access_timeouts.intervals.push(setInterval(() => {
                    this.notify('access');
                    this.notify('access:weekschedule');
                    return this.update();
                }, 60 * 60 * 1e3));
            }, ms_to_next_hour));
        }
    }
    has_pending_settings(pending_settings, request_code) {
        if (arguments.length === 0) {
            return this._pending_settings?.length > 0;
        }
        else {
            if (this._pending_settings_request_code == null ||
                request_code == null ||
                request_code > this._pending_settings_request_code ||
                (request_code === this._pending_settings_request_code &&
                    pending_settings?.length === 0)) {
                this._pending_settings = pending_settings;
                this._pending_settings_request_code = request_code;
                return this.notify('has_pending_settings');
            }
            return false;
        }
    }
    // async fix_hw205_amr(callback) {
    //     try {
    //         await this._ui.api.call_v2({
    //             method: 'fix_hw205_amr',
    //             data: { device_id: this.id()
    //         }
    //         });
    //
    //         return callback({ok: true});
    //
    //     } catch (error) {
    //         const {json} = error;
    //         return callback({ok: false, error: (json != null ? json.error_ui : undefined) != null ? (json != null ? json.error_ui : undefined) : 'Не удалось назначить операцию'});
    //     }
    // },
    async update() {
        const json = await this._ui.api.request_devices([this.id()]);
        const dev = json.devices[0];
        this._called_from_update = true;
        if (dev != null)
            this.set(dev);
        if (dev?.io != null)
            this.set(dev.io);
        this._called_from_update = false;
    }
    is_multi_thermostat() {
        return this.has_capability(Capability.has_l1000_multi);
    }
    thermostat_get_objects() {
        if (this.is_multi_thermostat())
            return this.l1000_config()?.objects || [];
        else
            return [
                {
                    object_id: '0',
                    name: 'Термостат',
                    channels: [
                        {
                            name: 'Канал управления',
                            channel_id: '0',
                        },
                    ],
                },
            ];
    }
    thermostat_get_mode(object_id) {
        if (this.is_multi_thermostat())
            return this.thermostat_mode_multi()?.[object_id];
        else
            return this.thermostat_mode();
    }
    thermostat_get_gate(object_id) {
        if (this.is_multi_thermostat())
            return this.thermostat_gate_multi()?.[object_id];
        else
            return this.thermostat_gate();
    }
    thermostat_get_mode_temps(channel_id) {
        if (this.is_multi_thermostat())
            return this.thermostat_mode_temps_multi()?.[channel_id];
        else
            return this.thermostat_mode_temps();
    }
    thermostat_get_all_mode_temps() {
        if (this.is_multi_thermostat())
            return this.thermostat_mode_temps_multi();
        else
            return { 0: this.thermostat_mode_temps() };
    }
    thermostat_get_all_tempschedules() {
        if (this.is_multi_thermostat())
            return this.tempschedule_multi();
        else
            return { 0: this.tempschedule() };
    }
    _send_thermostat_settings(callback, setter) {
        return this.updateSettings(setter, callback, {
            ignore_server_response: true,
            obey_only_last_response: true,
        });
    }
    _set_thermostat_multi_property(propname, key, value) {
        let left;
        // @ts-ignore
        const multi = (left = this[propname]()) != null ? left : {};
        if (typeof value === 'object')
            multi[key] = $.extend(multi[key], value);
        else
            multi[key] = value;
        // @ts-ignore
        return this[propname](multi);
    }
    thermostat_set_mode(object_id, mode, callback) {
        if (this.is_multi_thermostat()) {
            this._set_thermostat_multi_property('thermostat_mode_multi', object_id, mode);
            this._set_thermostat_multi_property('thermostat_gate_multi', object_id, false);
        }
        else {
            this.thermostat_mode(mode);
            this.thermostat_gate(false);
        }
        this._send_thermostat_settings(callback, (() => {
            if (this.is_multi_thermostat()) {
                const setter = {
                    thermostat_mode_multi: {},
                    thermostat_gate_multi: {},
                };
                // @ts-ignore
                setter.thermostat_mode_multi[object_id] = mode;
                // @ts-ignore
                setter.thermostat_gate_multi[object_id] = false;
                return setter;
            }
            else {
                return {
                    thermostat_mode: mode,
                    thermostat_gate: false,
                };
            }
        })());
    }
    thermostat_set_gate(object_id, gate, callback) {
        if (this.is_multi_thermostat()) {
            this._set_thermostat_multi_property('thermostat_gate_multi', object_id, gate);
        }
        else {
            this.thermostat_gate(gate);
        }
        return this._send_thermostat_settings(callback, (() => {
            if (this.is_multi_thermostat()) {
                const setter = { thermostat_gate_multi: {} };
                // @ts-ignore
                setter.thermostat_gate_multi[object_id] = gate;
                return setter;
            }
            else {
                return { thermostat_gate: gate };
            }
        })());
    }
    thermostat_set_mode_temps(channel_id, temps, callback) {
        if (this.is_multi_thermostat()) {
            this._set_thermostat_multi_property('thermostat_mode_temps_multi', channel_id, temps);
        }
        else {
            this._thermostat_mode_temps = $.extend(this._thermostat_mode_temps, temps);
            this.thermostat_mode_temps(this._thermostat_mode_temps);
        }
        return this._send_thermostat_settings(callback, (() => {
            if (this.is_multi_thermostat()) {
                const setter = { thermostat_mode_temps_multi: {} };
                // @ts-ignore
                setter.thermostat_mode_temps_multi[channel_id] = temps;
                return setter;
            }
            else {
                return { thermostat_mode_temps: temps };
            }
        })());
    }
    thermostat_set_multiple_mode_temps(channel_to_temps, callback) {
        if (this.is_multi_thermostat()) {
            let multi = this.thermostat_mode_temps_multi();
            multi = $.extend(true, multi, channel_to_temps);
            this.thermostat_mode_temps_multi(multi);
            return this._send_thermostat_settings(callback, {
                thermostat_mode_temps_multi: channel_to_temps,
            });
        }
        else {
            // fallback to thermostat_set_mode_temps
            return this.thermostat_set_mode_temps('0', channel_to_temps[0], callback);
        }
    }
    //    rf_set_names: (serial2name) ->
    //        @_ui.api.call
    //            method: 'rf_set_names'
    //            data:
    //                device_id: @id()
    //                serial2name: serial2name
    //
    //            success: =>
    //                rf_status = @rf_status() ? {}
    //                for own serial, name of serial2name
    //                    rf_status[serial] = Object.assign {}, rf_status[serial], {name}
    //                @rf_status rf_status
    // async send_custom_command(command_id, callback) {
    //     let comet_listener = null;
    //     if (callback != null) {
    //         comet_listener = {
    //             once: true,
    //             event: 'send_custom_command_response',
    //             condition: {
    //                 device_id: this.id()
    //             },
    //             callback
    //         };
    //         this._ui.comet.listen(comet_listener);
    //     }
    //
    //     try {
    //         return await this._ui.api.call_v2({
    //             method: 'send_custom_command',
    //             data: {
    //                 device_id: this.id(),
    //                 command_id
    //             }
    //         });
    //
    //     } catch (error) {
    //         const {json} = error;
    //         if (comet_listener != null) {
    //             this._ui.comet.unlisten(comet_listener);
    //
    //             return callback({
    //                 ok: false,
    //                 error: (json != null ? json.error_ui : undefined) != null ? (json != null ? json.error_ui : undefined) : 'Не удалось отправить команду'
    //             });
    //         }
    //     }
    // },
    // has_guard() { return this.has_capability('has_guard_state') || this.thermostat_enable_guard(); },
    _is_t10x() {
        return LegacyDevice._is_t10x({ device_type: this._device_type });
    }
    _is_l1() {
        return LegacyDevice._is_l1({ device_type: this._device_type });
    }
    _is_sx() {
        return LegacyDevice._is_sx({ device_type: this._device_type });
    }
    _is_l1000() {
        return LegacyDevice._is_l1000({ device_type: this._device_type });
    }
    _is_h1000() {
        return LegacyDevice._is_h1000({ device_type: this._device_type });
    }
    supports_thermostat_ext_modes() {
        return LegacyDevice.supports_thermostat_ext_modes({
            device_type: this._device_type,
            capabilities: this._capabilities,
            firmware_version: this._firmware_version,
            thermostat_enabled: this._thermostat_enabled,
        });
    }
    supports_extmodes_dayschedules() {
        if (this.has_capability(Capability.has_extmodes_dayschedules))
            return true;
        if (this._is_t10x() &&
            this._firmware_version?.[1] &&
            this._firmware_version?.[1] >= 89)
            return true;
        if (this._is_l1() &&
            this._firmware_version?.[1] &&
            this._firmware_version?.[1] >= 89)
            return true;
        if (this._is_sx() &&
            this._firmware_version?.[1] &&
            this._firmware_version?.[1] >= 183)
            return true;
        return false;
    }
    supports_extmodes_sensors() {
        if (this.has_capability(Capability.has_extmodes_sensors))
            return true;
        if (this._is_t10x() &&
            this._firmware_version?.[1] &&
            this._firmware_version?.[1] >= 89)
            return true;
        if (this._is_l1() &&
            this._firmware_version?.[1] &&
            this._firmware_version?.[1] >= 89)
            return true;
        if (this._is_sx() &&
            this._firmware_version?.[1] &&
            this._firmware_version?.[1] >= 183)
            return true;
        return false;
    }
    supports_multiple_thermometer_functions() {
        if (this.has_capability(Capability.has_multiple_thermometer_functions))
            return true;
        if (this._is_t10x() &&
            this._firmware_version?.[1] &&
            this._firmware_version?.[1] >= 89)
            return true;
        if (this._is_l1() &&
            this._firmware_version?.[1] &&
            this._firmware_version?.[1] >= 89)
            return true;
        if (this._is_sx() &&
            this._firmware_version?.[1] &&
            this._firmware_version?.[1] >= 183)
            return true;
        return false;
    }
    supports_rf_graphs() {
        if (this._is_t10x() &&
            this._firmware_version?.[1] &&
            this._firmware_version?.[1] >= 81)
            return true;
        if (this._is_l1() &&
            this._firmware_version?.[1] &&
            this._firmware_version?.[1] >= 81)
            return true;
        if (this._is_sx() &&
            this._firmware_version?.[1] &&
            this._firmware_version?.[1] >= 183)
            return true;
        return false;
    }
    supports_custom_controls_schedule() {
        if (this._is_sx() &&
            this._firmware_version?.[1] &&
            this._firmware_version?.[1] >= 171)
            return true;
        if (this._is_l1000() &&
            this._firmware_version?.[0] &&
            this._firmware_version?.[0] >= 266 &&
            this._firmware_version?.[1] &&
            this._firmware_version?.[1] >= 17)
            return true;
        return false;
    }
    supports_heatsettemp() {
        if (this._is_sx() &&
            this._firmware_version?.[1] &&
            this._firmware_version?.[1] >= 188)
            return true;
        if (this._is_t10x() &&
            this._firmware_version?.[1] &&
            this._firmware_version?.[1] >= 109)
            return true;
        if (this._is_l1() &&
            this._firmware_version?.[1] &&
            this._firmware_version?.[1] >= 109)
            return true;
        return false;
    }
    supports_ztc_state_graphs() {
        if (this.has_capability(Capability.has_ztc_state_packets))
            return true;
        if (this._is_t10x() &&
            this._firmware_version?.[1] &&
            this._firmware_version[1] >= 100)
            return true;
        if (this._is_l1() &&
            this._firmware_version?.[1] &&
            this._firmware_version[1] >= 100)
            return true;
        if ((this._is_sx() || this._is_h1000()) &&
            this._firmware_version?.[1] &&
            this._firmware_version[1] >= 210)
            return true;
        return false;
    }
    supports_otzones_packets() {
        if ((this._is_h1000() || this._is_sx()) &&
            this._firmware_version?.[1] &&
            this._firmware_version[1] >= 210)
            return true;
        return false;
    }
    rf_color(serial) {
        return LegacyDevice.rf_color(this._thermometers, serial);
    }
    current_server_time() {
        return this._ui.current_server_time();
    }
    has_thermostat_service_password() {
        return LegacyDevice.has_thermostat_service_password(this.firmware_version() || null, this.device_type());
    }
    check_thermostat_service_password(input) {
        return LegacyDevice.check_thermostat_service_password({
            device_type: this.device_type(),
            thermostat_service_password: this.thermostat_service_password(),
            serial: this.serial(),
        }, input);
    }
    thermostat_service_password_not_empty() {
        return LegacyDevice.thermostat_service_password_not_empty({
            device_type: this.device_type(),
            thermostat_service_password: this.thermostat_service_password(),
        });
    }
    thermostat_service_password_dialog_footer() {
        return LegacyDevice.thermostat_service_password_dialog_footer({
            device_type: this.device_type(),
        });
    }
    thermostat_service_password_invalid_text() {
        return LegacyDevice.thermostat_service_password_invalid_text({
            device_type: this.device_type(),
        });
    }
    display_name() {
        return LegacyDevice.display_name({
            name: this.name(),
            autoscan_settings: this.autoscan_settings(),
        });
    }
    async get_boiler_models(callback) {
        try {
            const { boiler_models } = await this._ui.api.get_boiler_models_v2();
            const boiler_models_flat = prepare_boiler_models(boiler_models);
            return callback({
                ok: true,
                boiler_types: boiler_models,
                boiler_models: boiler_models_flat,
            });
        }
        catch (error) {
            const { json } = error;
            return callback({
                ok: false,
                error: (json != null ? json.error_ui : undefined) != null
                    ? json != null
                        ? json.error_ui
                        : undefined
                    : 'Не удалось загрузить информацию',
            });
        }
    }
    // STATIC BLOCK
    static thermometer_by_slot = function (thermometers, slot) {
        for (const therm of thermometers != null ? thermometers : [])
            if (therm.slot === ~~slot)
                return therm;
        return null;
    };
    static thermometer_by_serial = function (thermometers, serial) {
        for (const therm of thermometers != null ? thermometers : [])
            if (therm.is_assigned_to_slot && therm.serial === serial)
                return therm;
        return null;
    };
    static rf_color = function (thermometers, serial) {
        const therm = LegacyDevice.thermometer_by_serial(thermometers, serial);
        return therm?.color || rf_color(serial);
    };
    static has_capability = (capabilities, codename) => (capabilities != null ? capabilities : []).includes(codename);
    static has_all_capabilities(capabilities, codenames) {
        return codenames.every((codename) => LegacyDevice.has_capability(capabilities, codename));
    }
    static has_any_capability = function (capabilities, codenames) {
        return codenames.some((cap) => LegacyDevice.has_capability(capabilities, cap));
    };
    static has_guard = (capabilities, thermostat_enable_guard) => LegacyDevice.has_capability(capabilities, Capability.has_guard_state) ||
        thermostat_enable_guard;
    static get_selected_device = function (r_devices, selected_device_id) {
        return (
        // @ts-ignore
        r_devices.find((dev) => dev.id === selected_device_id) ||
            // @ts-ignore
            r_devices[0] ||
            null);
    };
    static has_autoscan_settings = (capabilities, autoscan_settings) => LegacyDevice.has_capability(capabilities, Capability.has_autoscan_settings) ||
        autoscan_settings;
    static has_access = function (account_id, { user_id, access, timezone }, permissions, time = new Date()) {
        if (typeof permissions === 'string')
            permissions = [permissions];
        if (user_id === account_id)
            return true;
        if (access == null)
            return false;
        for (const acc of access) {
            if (acc.user_id === account_id) {
                if (acc.until != null && acc.until < time.getTime() / 1e3)
                    continue;
                let perms_met = true;
                for (const perm of permissions)
                    if (!acc.perms.includes(perm)) {
                        perms_met = false;
                        break;
                    }
                if (!perms_met)
                    continue;
                if (acc.weekschedule != null) {
                    const utcweekhour = __mod__(time.getUTCDay() - 1, 7) * 24 + time.getUTCHours();
                    const localweekhour = (utcweekhour + (timezone != null ? timezone : 3)) % (24 * 7);
                    if ((acc.weekschedule[parseInt(String(localweekhour / 24), 10)] &
                        (1 << localweekhour % 24)) ===
                        0)
                        continue;
                }
                return true;
            }
        }
        return false;
    };
    // Device.active_thermometers = r_device => (r_device.thermometers != null ? r_device.thermometers : []).filter((therm) => (therm != null ? therm.is_assigned_to_slot : undefined));
    static active_thermometers = (thermometers) => (thermometers || []).filter((therm) => therm?.is_assigned_to_slot);
    static control_thermometer_for_zone = function (r_device, zone_no) {
        for (const therm of LegacyDevice.active_thermometers(r_device?.thermometers || []))
            for (const func of therm.functions != null ? therm.functions : [])
                if (func.f === 'control' && func.zone === zone_no)
                    return therm;
        return null;
    };
    static rf_name = function (active_thermometers, rf_status, rf_serial) {
        for (const therm of active_thermometers)
            if (therm.serial === rf_serial)
                return therm.name;
        const object = rf_status != null ? rf_status : {};
        for (const serial of Object.keys(object || {})) {
            const rf_props = object[serial];
            if (serial === rf_serial)
                return rf_props.name;
        }
        return null;
    };
    static filetransfer_in_progress = function (filetransfers, type) {
        for (const ft of filetransfers != null ? filetransfers : []) {
            if (ft.done)
                continue;
            if (type != null && ft.type !== type)
                continue;
            return true;
        }
        return false;
    };
    static filetransfer_percent = function (device, type) {
        let progress_cnt;
        let progress_sum = (progress_cnt = 0);
        for (const ft of device.filetransfers != null ? device.filetransfers : []) {
            if (ft.done)
                continue;
            if (type != null && ft.type !== type)
                continue;
            progress_sum += ft.progress;
            progress_cnt++;
        }
        if (progress_cnt > 0)
            return parseInt(String((progress_sum / progress_cnt) * 100), 10);
        else
            return 0;
    };
    static _is_t10x = (device) => device.device_type?.code?.match(/^T10[02]$/);
    static _is_l1 = (device) => device.device_type?.code?.match(/^L1$/);
    static _is_sx = (device) => device.device_type?.code?.match(/^SX|^H1000$|^H2000$/);
    static _is_l1000 = (device) => device.device_type?.code?.match(/^L1000/);
    static _is_h1000 = (device) => {
        if (device.device_type?.code) {
            return ['H1000', 'H2000'].includes(device.device_type?.code);
        }
        return false;
    };
    static supports_thermostat_ext_modes = function (device) {
        if (LegacyDevice.has_capability(device?.capabilities, Capability.has_extmodes)) {
            return true;
        }
        if (LegacyDevice._is_t10x({ device_type: device.device_type }) &&
            device.firmware_version?.[1] &&
            device.firmware_version[1] >= 82) {
            return true;
        }
        if (LegacyDevice._is_l1({ device_type: device.device_type })) {
            return true;
        }
        if (LegacyDevice._is_sx({ device_type: device.device_type }) &&
            device.firmware_version?.[1] &&
            device.firmware_version[1] >= 172) {
            if (LegacyDevice.has_capability(device?.capabilities, Capability.has_thermostat)) {
                return true;
            }
            if (LegacyDevice.has_capability(device?.capabilities, Capability.has_optional_thermostat) &&
                device.thermostat_enabled) {
                return true;
            }
            return false;
        }
        return false;
    };
    static is_legacy_firmware = function (capabilities, thermostat_enabled, firmware_version, device_type) {
        if (LegacyDevice.has_capability(capabilities, Capability.has_z3k_settings)) {
            return false;
        }
        const is_thermostat = LegacyDevice.has_capability(capabilities, Capability.has_thermostat) ||
            (LegacyDevice.has_capability(capabilities, Capability.has_optional_thermostat) &&
                thermostat_enabled);
        return (is_thermostat &&
            !LegacyDevice.supports_thermostat_ext_modes({
                thermostat_enabled: thermostat_enabled,
                firmware_version,
                device_type,
                capabilities,
            }));
    };
    static is_legacy_heating = function (capabilities, thermostat_enabled, device_type, firmware_version) {
        if (LegacyDevice.has_capability(capabilities, Capability.has_z3k_settings)) {
            return false;
        }
        const is_thermostat = LegacyDevice.has_capability(capabilities, Capability.has_thermostat) ||
            (LegacyDevice.has_capability(capabilities, Capability.has_optional_thermostat) &&
                thermostat_enabled);
        return (is_thermostat &&
            LegacyDevice.supports_thermostat_ext_modes({
                capabilities,
                thermostat_enabled,
                device_type,
                firmware_version,
            }));
    };
    static thermostat_gate_available = function (device) {
        const inputconf = device.thermostat_inputconfig;
        if (inputconf?.[1] === 'gate' || inputconf?.[2] === 'gate')
            return true;
        if (device.ot_enabled && device.ot_gate_enabled)
            return true;
        return false;
    };
    static has_thermostat_service_password = function (firmware_version, device_type) {
        const devtype = device_type?.code;
        if (((devtype && ['H1000', 'H2000'].includes(devtype)) ||
            devtype?.startsWith('SX')) &&
            firmware_version?.[1] &&
            firmware_version[1] >= 231) {
            return true;
        }
        if (devtype?.startsWith('GTW-')) {
            return true;
        }
        return false;
    };
    static check_thermostat_service_password = function ({ device_type, thermostat_service_password, serial }, input) {
        if (device_type?.code.startsWith('GTW-')) {
            const tail = serial.substring(serial.length - 4);
            return (input
                .replace(/а/gi, 'a')
                .replace(/в/gi, 'b')
                .replace(/с/gi, 'c')
                .replace(/е/gi, 'e')
                .replace(/[оo]/gi, '0')
                .replace(/i/gi, '1')
                .toLowerCase() === tail.toLowerCase());
        }
        return thermostat_service_password === input;
    };
    static thermostat_service_password_not_empty = function ({ device_type, thermostat_service_password, }) {
        if (device_type?.code.startsWith('GTW-'))
            return true;
        return (thermostat_service_password != null && thermostat_service_password !== '');
    };
    static thermostat_service_password_dialog_footer = function ({ device_type }) {
        if (device_type?.code.startsWith('GTW-'))
            return '';
        return 'Сервисный пароль задаётся установщиком при первоначальной настройке';
    };
    static thermostat_service_password_invalid_text = function ({ device_type }) {
        if (device_type?.code.startsWith('GTW-'))
            return '';
        return 'Задать новый пароль можно с помощью Настроечной утилиты';
    };
    static supports_reports = function (device) {
        // @ts-ignore
        if (device.autoscan_settings != null)
            return true;
        if (device.device_type?.code != null &&
            ['E-100', 'G-100'].includes(device.device_type.code))
            return true;
        return false;
    };
    static display_name = function ({ autoscan_settings, individual_device_name, name, }) {
        if (autoscan_settings?.params?.Name != null) {
            return `${autoscan_settings.params.Name} ${autoscan_settings.number || ''}`;
        }
        return individual_device_name?.trim() !== ''
            ? individual_device_name ?? name ?? ''
            : name ?? '';
    };
    static supports_settings = function (device_type_code) {
        // return device_type_code !== 'VALTEC_K300';
        return true;
    };
    // GET SET BLOCK
    id(value) {
        if (value !== undefined) {
            this._id = value;
        }
        return this._id;
    }
    serial(value) {
        if (value !== undefined) {
            this._serial = value;
        }
        return this._serial;
    }
    name(value) {
        if (value !== undefined) {
            this._name = value;
        }
        return this._name;
    }
    color(value) {
        if (value !== undefined) {
            this._color = value;
        }
        return this._color;
    }
    timezone(value) {
        if (value !== undefined) {
            this._timezone = value;
            this.notify('access');
        }
        return this._timezone;
    }
    is_active(value) {
        if (value !== undefined) {
            this._is_active = value;
        }
        return this._is_active;
    }
    hardware_type(value) {
        if (value !== undefined) {
            this._hardware_type = value;
        }
        return this._hardware_type;
    }
    device_type(value) {
        if (value !== undefined) {
            this._device_type = value;
        }
        return this._device_type;
    }
    capabilities(value) {
        if (value !== undefined) {
            this._capabilities = value;
        }
        return this._capabilities || [];
    }
    firmware_version(value) {
        if (value !== undefined) {
            this._firmware_version = value;
            this.notify('firmware_upgrade_available');
        }
        return this._firmware_version;
    }
    firmware_upgrade_available() {
        if (this.has_thermostat_service_password())
            return false;
        const my = this._firmware_version;
        const last = this.last_firmware_version();
        if (my == null || last == null)
            return false;
        return my[0] < last[0] || (my[0] === last[0] && my[1] < last[1]);
    }
    online(value) {
        if (value !== undefined) {
            let prev;
            [prev, this._online] = [this._online, value];
            if (this._online)
                this.just_installed_firmware(false);
            else {
                // @_resetIOPorts()
                // @ts-ignore
                if (prev)
                    this.last_connect_time(new Date());
            }
        }
        return this._online;
    }
    temperature_conf(value) {
        if (value !== undefined) {
            this._temperature_conf = value;
        }
        return this._temperature_conf;
    }
    temperature(value) {
        if (value !== undefined) {
            this._temperature = value;
        }
        return this._temperature;
    }
    gps_state(value) {
        if (value !== undefined) {
            this._gps_state = value;
        }
        return this._gps_state;
    }
    gsm_state(value) {
        if (value !== undefined) {
            this._gsm_state = value;
        }
        return this._gsm_state;
    }
    balance(value) {
        if (value !== undefined) {
            // FIXME: The server sends {event: 'updated', balance: {value: 'xxx'}} events for the
            // FIXME: sake of the old mobile app. Following code is needed to make these events
            // FIXME: to merge into existing `balance` setting value instead of overwriting it.
            // FIXME: Remove this when the old mobile app will reach end-of-life. (tag: old-app-balance)
            this._balance = {
                ...(this._balance != null ? this._balance : {}),
                ...(value != null ? value : {}),
            };
        }
        return this._balance;
    }
    auto_ignition(value) {
        if (value !== undefined) {
            this._auto_ignition = value;
            if (this._auto_ignition_timer) {
                clearInterval(this._auto_ignition_timer);
                this._auto_ignition_timer = null;
            }
            if (value?.until && value?.until > new Date().getTime() / 1e3) {
                const update = () => {
                    const now = parseInt(String(new Date().getTime() / 1e3), 10);
                    this.auto_ignition_timeout(
                    // @ts-ignore
                    parseInt(this._auto_ignition.until - now, 10));
                    if (this.auto_ignition_timeout() <= 0) {
                        clearInterval(this._auto_ignition_timer);
                        this._auto_ignition_timer = null;
                    }
                };
                this._auto_ignition_timer = setInterval(update, 1000);
                update();
            }
            else
                this.auto_ignition_timeout(null);
        }
        return this._auto_ignition;
    }
    auto_ignition_timeout(value) {
        if (value !== undefined) {
            this._auto_ignition_timeout = value;
        }
        return this._auto_ignition_timeout;
    }
    voltage(value) {
        if (value !== undefined) {
            this._voltage = value;
        }
        return this._voltage;
    }
    power_source(value) {
        if (value !== undefined) {
            this._power_source = value;
        }
        return this._power_source;
    }
    current_ecu_errors(value) {
        if (value !== undefined) {
            this._current_ecu_errors = value;
        }
        return this._current_ecu_errors;
    }
    saved_ecu_errors(value) {
        if (value !== undefined) {
            this._saved_ecu_errors = value;
        }
        return this._saved_ecu_errors;
    }
    suggest_firmware_upgrade(value) {
        if (value !== undefined) {
            this._suggest_firmware_upgrade = value;
        }
        return this._suggest_firmware_upgrade;
    }
    guard_state(value) {
        if (value !== undefined) {
            this._guard_state = value;
        }
        return this._guard_state;
    }
    filetransfers(value) {
        if (value !== undefined) {
            this._filetransfers = value;
        }
        return this._filetransfers;
    }
    just_installed_firmware(value) {
        if (value !== undefined) {
            this._just_installed_firmware = value;
        }
        return this._just_installed_firmware;
    }
    fuel_consumption(value) {
        if (value !== undefined) {
            this._fuel_consumption = value;
        }
        return this._fuel_consumption;
    }
    trusted_phones(value) {
        if (value !== undefined) {
            if (typeof value === 'string') {
                this._trusted_phones = $.map(value.split(','), (s) => s.trim());
                if (this._trusted_phones[0] === '')
                    this._trusted_phones = [];
            }
            else
                this._trusted_phones = value;
        }
        return this._trusted_phones;
    }
    accel_params(value) {
        if (value !== undefined) {
            this._accel_params = value;
        }
        return this._accel_params;
    }
    auto_ignition_duration(value) {
        if (value !== undefined) {
            this._auto_ignition_duration = value;
        }
        return this._auto_ignition_duration;
    }
    auto_ignition_params(value) {
        if (value !== undefined) {
            this._auto_ignition_params = value;
        }
        return this._auto_ignition_params;
    }
    auto_ignition_schedule(value) {
        if (value !== undefined) {
            this._auto_ignition_schedule = value;
        }
        return this._auto_ignition_schedule;
    }
    last_receive_time_relative(value) {
        if (value !== undefined) {
            // @ts-ignore
            this.last_connect_time(new Date(new Date().getTime() - value * 1000));
        }
        return this._last_receive_time_relative;
    }
    last_connect_time(value) {
        if (value !== undefined) {
            this._last_connect_time = value;
        }
        return this._last_connect_time;
    }
    gps_relevance_relative(value) {
        if (value !== undefined) {
            if (value != null)
                this.gps_relevance_absolute(new Date(new Date().getTime() - value * 1000));
        }
        return this._gps_relevance_relative;
    }
    gps_relevance_absolute(value) {
        if (value !== undefined) {
            this._gps_relevance_absolute = value;
        }
        return this._gps_relevance_absolute;
    }
    doors(value) {
        if (value !== undefined) {
            this._doors = value;
        }
        return this._doors;
    }
    door_1(value) {
        if (value !== undefined) {
            this._door_1 = value;
        }
        return this._door_1;
    }
    door_2(value) {
        if (value !== undefined) {
            this._door_2 = value;
        }
        return this._door_2;
    }
    door_3(value) {
        if (value !== undefined) {
            this._door_3 = value;
        }
        return this._door_3;
    }
    door_4(value) {
        if (value !== undefined) {
            this._door_4 = value;
        }
        return this._door_4;
    }
    hood_trunk(value) {
        if (value !== undefined) {
            this._hood_trunk = value;
        }
        return this._hood_trunk;
    }
    hood(value) {
        if (value !== undefined) {
            this._hood = value;
        }
        return this._hood;
    }
    trunk(value) {
        if (value !== undefined) {
            this._trunk = value;
        }
        return this._trunk;
    }
    engine_state(value) {
        if (value !== undefined) {
            this._engine_state = value;
        }
        return this._engine_state;
    }
    engine_block(value) {
        if (value !== undefined) {
            this._engine_block = value;
        }
        return this._engine_block;
    }
    siren(value) {
        if (value !== undefined) {
            this._siren = value;
        }
        return this._siren;
    }
    webasto(value) {
        if (value !== undefined) {
            this._webasto = value;
        }
        return this._webasto;
    }
    notifications(value) {
        if (value !== undefined) {
            this._notifications = value;
        }
        return this._notifications;
    }
    server_notifications(value) {
        if (value !== undefined) {
            this._server_notifications = value;
        }
        return this._server_notifications;
    }
    autoguard(value) {
        if (value !== undefined) {
            this._autoguard = value;
        }
        return this._autoguard;
    }
    radiosilence(value) {
        if (value !== undefined) {
            this._radiosilence = value;
        }
        return this._radiosilence;
    }
    radiosilence_planned(value) {
        if (value !== undefined) {
            this._radiosilence_planned = value;
        }
        return this._radiosilence_planned;
    }
    thermometers(value) {
        if (value !== undefined) {
            this._thermometers = value;
        }
        return this._thermometers;
    }
    thermometers_reset_in_progress(value) {
        if (value !== undefined) {
            // this._thermometers_reset_in_progress = !!value;
            if (value !== undefined) {
                this._thermrestimer = setTimeout(() => {
                    return this.thermometers_reset_in_progress(false);
                }, 120 * 1000);
            }
            else {
                if (this._thermrestimer)
                    clearTimeout(this._thermrestimer);
                this._thermrestimer = null;
            }
            this.notify('thermometers');
        }
        return this._thermometers_reset_in_progress;
    }
    tempschedule(value) {
        if (value !== undefined) {
            this._tempschedule = value;
        }
        return this._tempschedule;
    }
    tempschedule_multi(value) {
        if (value !== undefined) {
            this._tempschedule_multi = value;
        }
        return this._tempschedule_multi;
    }
    thermostat_mode(value) {
        if (value !== undefined) {
            this._thermostat_mode = value;
        }
        return this._thermostat_mode;
    }
    thermostat_mode_multi(value) {
        if (value !== undefined) {
            this._thermostat_mode_multi = value;
        }
        return this._thermostat_mode_multi;
    }
    thermostat_gate(value) {
        if (value !== undefined) {
            this._thermostat_gate = value;
        }
        return this._thermostat_gate;
    }
    thermostat_gate_multi(value) {
        if (value !== undefined) {
            this._thermostat_gate_multi = value;
        }
        return this._thermostat_gate_multi;
    }
    thermostat_gate_available(value) {
        if (value !== undefined) {
            this._thermostat_gate_available = value;
        }
        const inputconf = this.thermostat_inputconfig();
        if (inputconf?.[1] === 'gate' || inputconf?.[2] === 'gate')
            return true;
        if (this.ot_enabled() && this.ot_gate_enabled())
            return true;
        return false;
    }
    thermostat_mode_temps(value) {
        if (value !== undefined) {
            this._thermostat_mode_temps = value;
        }
        return this._thermostat_mode_temps;
    }
    thermostat_mode_temps_multi(value) {
        if (value !== undefined) {
            this._thermostat_mode_temps_multi = value;
        }
        return this._thermostat_mode_temps_multi;
    }
    temperature_alarm(value) {
        if (value !== undefined) {
            this._temperature_alarm = value;
        }
        return this._temperature_alarm;
    }
    thermostat_ext_mode(value) {
        if (value !== undefined) {
            this._thermostat_ext_mode = value;
        }
        return this._thermostat_ext_mode;
    }
    thermostat_ext_modes_config(value) {
        if (value !== undefined) {
            this._thermostat_ext_modes_config = value;
        }
        return this._thermostat_ext_modes_config;
    }
    thermostat_ext_modes_advanced(value) {
        if (value !== undefined) {
            this._thermostat_ext_modes_advanced = value;
        }
        return this._thermostat_ext_modes_advanced;
    }
    thermostat_target_temps(value) {
        if (value !== undefined) {
            this._thermostat_target_temps = value;
        }
        return this._thermostat_target_temps;
    }
    thermostat_zones_settings(value) {
        if (value !== undefined) {
            this._thermostat_zones_settings = value;
        }
        return this._thermostat_zones_settings;
    }
    ot_zones_count(value) {
        if (value !== undefined) {
            this._ot_zones_count = value;
        }
        return this._ot_zones_count;
    }
    thermostat_temps_limits(value) {
        if (value !== undefined) {
            this._thermostat_temps_limits = value;
        }
        return this._thermostat_temps_limits;
    }
    notes(value) {
        if (value !== undefined) {
            this._notes = value;
        }
        return this._notes;
    }
    thermostat_hysteresis(value) {
        if (value !== undefined) {
            this._thermostat_hysteresis = value;
        }
        return this._thermostat_hysteresis;
    }
    thermostat_error_input_polarity(value) {
        if (value !== undefined) {
            this._thermostat_error_input_polarity = value;
        }
        return this._thermostat_error_input_polarity;
    }
    // This IO port doesn't updates its value when camera is connected or disconnected
    // But comparsion with null might be used to check if device supports camera
    camera_available(value) {
        if (value !== undefined) {
            this._camera_available = value;
        }
        return this._camera_available;
    }
    camera_count(value) {
        if (value !== undefined) {
            this._camera_count = value;
        }
        return this._camera_count;
    }
    tracker_mode(value) {
        if (value !== undefined) {
            this._tracker_mode = value;
        }
        return this._tracker_mode;
    }
    thermostat_inputconfig(value) {
        if (value !== undefined) {
            this._thermostat_inputconfig = value;
            this.notify('capabilities');
            this.notify('thermostat_gate_available');
        }
        return this._thermostat_inputconfig;
    }
    thermostat_enable_guard(value) {
        if (value !== undefined) {
            this._thermostat_enable_guard = value;
        }
        return this._thermostat_enable_guard;
    }
    thermostat_relay_mode(value) {
        if (value !== undefined) {
            this._thermostat_relay_mode = value;
        }
        return this._thermostat_relay_mode;
    }
    ztc110_inputconfig(value) {
        if (value !== undefined) {
            this._ztc110_inputconfig = value;
        }
        return this._ztc110_inputconfig;
    }
    ztc110_guard_polarity(value) {
        if (value !== undefined) {
            this._ztc110_guard_polarity = value;
        }
        return this._ztc110_guard_polarity;
    }
    zta110_inputconfig(value) {
        if (value !== undefined) {
            this._zta110_inputconfig = value;
        }
        return this._zta110_inputconfig;
    }
    zta110_outputconfig(value) {
        if (value !== undefined) {
            this._zta110_outputconfig = value;
        }
        return this._zta110_outputconfig;
    }
    last_guard_event(value) {
        if (value !== undefined) {
            this._last_guard_event = value;
        }
        return this._last_guard_event;
    }
    last_boiler_state(value) {
        if (value !== undefined) {
            this._last_boiler_state = value;
        }
        return this._last_boiler_state;
    }
    webasto_timeout(value) {
        if (value !== undefined) {
            this._webasto_timeout = value;
        }
        return this._webasto_timeout;
    }
    thermostat_enabled(value) {
        if (value !== undefined) {
            this._thermostat_enabled = value;
        }
        return this._thermostat_enabled;
    }
    ot_enabled(value) {
        if (value !== undefined) {
            this._ot_enabled = value;
        }
        return this._ot_enabled;
    }
    ot_mode(value) {
        if (value !== undefined) {
            this._ot_mode = value;
        }
        return this._ot_mode;
    }
    ot_save_params(value) {
        if (value !== undefined) {
            this._ot_save_params = value;
        }
        return this._ot_save_params;
    }
    ot_config(value) {
        if (value !== undefined) {
            this._ot_config = value;
        }
        return this._ot_config;
    }
    ot_show_dhw_control(value) {
        if (value !== undefined) {
            this._ot_show_dhw_control = value;
        }
        return this._ot_show_dhw_control;
    }
    ot_min_wp(value) {
        if (value !== undefined) {
            this._ot_min_wp = value;
        }
        return this._ot_min_wp;
    }
    ot_max_ml(value) {
        if (value !== undefined) {
            this._ot_max_ml = value;
        }
        return this._ot_max_ml;
    }
    ot_min_setpoint(value) {
        if (value !== undefined) {
            this._ot_min_setpoint = value;
        }
        return this._ot_min_setpoint;
    }
    ot_max_setpoint(value) {
        if (value !== undefined) {
            this._ot_max_setpoint = value;
        }
        return this._ot_max_setpoint;
    }
    ot_dhw_setpoint(value) {
        if (value !== undefined) {
            this._ot_dhw_setpoint = value;
        }
        return this._ot_dhw_setpoint;
    }
    ot_boiler_type(value) {
        if (value !== undefined) {
            this._ot_boiler_type = value;
        }
        return this._ot_boiler_type;
    }
    ot_gate_enabled(value) {
        if (value !== undefined) {
            this._ot_gate_enabled = value;
            this.notify('thermostat_gate_available');
        }
        return this._ot_gate_enabled;
    }
    rf_status(value) {
        if (value !== undefined) {
            const rf = {};
            for (const k of Object.keys(value || {})) {
                // @ts-ignore
                rf[k.replace(/^s_/, '')] = value[k];
            }
            this._rf_status = rf;
        }
        return this._rf_status;
    }
    tempstep(value) {
        if (value !== undefined) {
            this._tempstep = value != null ? value : 1;
        }
        return this._tempstep;
    }
    __temporary_thermometer_names(value) {
        if (value !== undefined) {
            this.___temporary_thermometer_names = value;
        }
        return this.___temporary_thermometer_names;
    }
    wifi_credentials(value) {
        if (value !== undefined) {
            this._wifi_credentials = value;
        }
        return this._wifi_credentials;
    }
    ecu_diagnostics_enabled(value) {
        if (value !== undefined) {
            this._ecu_diagnostics_enabled = value;
        }
        return this._ecu_diagnostics_enabled;
    }
    ecu_diagnostics_active(value) {
        if (value !== undefined) {
            this._ecu_diagnostics_active = value;
        }
        return this._ecu_diagnostics_active;
    }
    battery_percent(value) {
        if (value !== undefined) {
            this._battery_percent = value;
        }
        return this._battery_percent;
    }
    voicesiren_soundpack(value) {
        if (value !== undefined) {
            this._voicesiren_soundpack = value;
        }
        return this._voicesiren_soundpack;
    }
    siren_loudness(value) {
        if (value !== undefined) {
            this._siren_loudness = value;
        }
        return this._siren_loudness;
    }
    handsfree(value) {
        if (value !== undefined) {
            this._handsfree = value;
        }
        return this._handsfree;
    }
    ztcconfig_autostart(value) {
        if (value !== undefined) {
            this._ztcconfig_autostart = value;
        }
        return this._ztcconfig_autostart;
    }
    ztcconfig_locking(value) {
        if (value !== undefined) {
            this._ztcconfig_locking = value;
        }
        return this._ztcconfig_locking;
    }
    ztcconfig_battery(value) {
        if (value !== undefined) {
            this._ztcconfig_battery = value;
        }
        return this._ztcconfig_battery;
    }
    ztcconfig_siren(value) {
        if (value !== undefined) {
            this._ztcconfig_siren = value;
        }
        return this._ztcconfig_siren;
    }
    ztc_savestate(value) {
        if (value !== undefined) {
            this._ztc_savestate = value;
        }
        return this._ztc_savestate;
    }
    gsm_roaming(value) {
        if (value !== undefined) {
            this._gsm_roaming = value;
        }
        return this._gsm_roaming;
    }
    service_password_set(value) {
        if (value !== undefined) {
            this._service_password_set = value;
        }
        return this._service_password_set;
    }
    boiler_info(value) {
        if (value !== undefined) {
            this._boiler_info = value;
        }
        return this._boiler_info;
    }
    pza(value) {
        if (value !== undefined) {
            this._pza = value;
        }
        return this._pza;
    }
    pza_max_delta(value) {
        if (value !== undefined) {
            this._pza_max_delta = value;
        }
        return this._pza_max_delta;
    }
    boiler_delay(value) {
        if (value !== undefined) {
            this._boiler_delay = value;
        }
        return this._boiler_delay;
    }
    user_id(value) {
        if (value !== undefined) {
            this._user_id = value;
        }
        return this._user_id;
    }
    owner_username(value) {
        if (value !== undefined) {
            this._owner_username = value;
        }
        return this._owner_username;
    }
    access(value) {
        if (value !== undefined) {
            this._access = value;
            this._reschedule_access_timeouts();
            if (!this._called_from_update)
                this.update();
        }
        return this._access;
    }
    l1000_config(value) {
        if (value !== undefined) {
            this._l1000_config = value;
        }
        return this._l1000_config;
    }
    custom_controls(value) {
        if (value !== undefined) {
            this._custom_controls = value;
        }
        return this._custom_controls;
    }
    custom_controls_state(value) {
        if (value !== undefined) {
            this._custom_controls_state = value;
        }
        return this._custom_controls_state;
    }
    custom_controls_schedule(value) {
        if (value !== undefined) {
            this._custom_controls_schedule = value;
        }
        return this._custom_controls_schedule;
    }
    debug_text_messages_regexp(value) {
        if (value !== undefined) {
            this._debug_text_messages_regexp = value;
        }
        return this._debug_text_messages_regexp;
    }
    // GTW settings
    gtw_boiler_version(value) {
        if (value !== undefined) {
            this._gtw_boiler_version = value;
        }
        return this._gtw_boiler_version;
    }
    gtw_mode(value) {
        if (value !== undefined) {
            this._gtw_mode = value;
        }
        return this._gtw_mode;
    }
    gtw_heat(value) {
        if (value !== undefined) {
            this._gtw_heat = value;
        }
        return this._gtw_heat;
    }
    gtw_service_mode(value) {
        if (value !== undefined) {
            this._gtw_service_mode = value;
        }
        return this._gtw_service_mode;
    }
    gtw_fail(value) {
        if (value !== undefined) {
            this._gtw_fail = value;
        }
        return this._gtw_fail;
    }
    gtw_fail_countdown(value) {
        if (value !== undefined) {
            this._gtw_fail_countdown = value;
        }
        return this._gtw_fail_countdown;
    }
    gtw_ten_count(value) {
        if (value !== undefined) {
            this._gtw_ten_count = value;
        }
        return this._gtw_ten_count;
    }
    gtw_ten_max(value) {
        if (value !== undefined) {
            this._gtw_ten_max = value;
        }
        return this._gtw_ten_max;
    }
    gtw_sensors_valid(value) {
        if (value !== undefined) {
            this._gtw_sensors_valid = value;
        }
        return this._gtw_sensors_valid;
    }
    gtw_t_air_int_sensor(value) {
        if (value !== undefined) {
            this._gtw_t_air_int_sensor = value;
        }
        return this._gtw_t_air_int_sensor;
    }
    gtw_t_air_ext_sensor(value) {
        if (value !== undefined) {
            this._gtw_t_air_ext_sensor = value;
        }
        return this._gtw_t_air_ext_sensor;
    }
    gtw_t_water_sensor(value) {
        if (value !== undefined) {
            this._gtw_t_water_sensor = value;
        }
        return this._gtw_t_water_sensor;
    }
    gtw_t_water(value) {
        if (value !== undefined) {
            this._gtw_t_water = value;
        }
        return this._gtw_t_water;
    }
    gtw_t_air(value) {
        if (value !== undefined) {
            this._gtw_t_air = value;
        }
        return this._gtw_t_air;
    }
    gtw_t_air_comfort(value) {
        if (value !== undefined) {
            this._gtw_t_air_comfort = value;
        }
        return this._gtw_t_air_comfort;
    }
    gtw_t_air_econom(value) {
        if (value !== undefined) {
            this._gtw_t_air_econom = value;
        }
        return this._gtw_t_air_econom;
    }
    gtw_t_air_pza(value) {
        if (value !== undefined) {
            this._gtw_t_air_pza = value;
        }
        return this._gtw_t_air_pza;
    }
    gtw_t_water_set_disp(value) {
        if (value !== undefined) {
            this._gtw_t_water_set_disp = value;
        }
        return this._gtw_t_water_set_disp;
    }
    gtw_t_air_set_disp(value) {
        if (value !== undefined) {
            this._gtw_t_air_set_disp = value;
        }
        return this._gtw_t_air_set_disp;
    }
    gtw_p_water(value) {
        if (value !== undefined) {
            this._gtw_p_water = value;
        }
        return this._gtw_p_water;
    }
    gtw_thermostat_air(value) {
        if (value !== undefined) {
            this._gtw_thermostat_air = value;
        }
        return this._gtw_thermostat_air;
    }
    gtw_thermostat_gvs(value) {
        if (value !== undefined) {
            this._gtw_thermostat_gvs = value;
        }
        return this._gtw_thermostat_gvs;
    }
    gtw_time(value) {
        if (value !== undefined) {
            this._gtw_time = value;
        }
        return this._gtw_time;
    }
    gtw_temporary_end(value) {
        if (value !== undefined) {
            this._gtw_temporary_end = value;
        }
        return this._gtw_temporary_end;
    }
    gtw_nominal_power(value) {
        if (value !== undefined) {
            this._gtw_nominal_power = value;
        }
        return this._gtw_nominal_power;
    }
    gtw_interval_s_on(value) {
        if (value !== undefined) {
            this._gtw_interval_s_on = value;
        }
        return this._gtw_interval_s_on;
    }
    gtw_interval_s_off(value) {
        if (value !== undefined) {
            this._gtw_interval_s_off = value;
        }
        return this._gtw_interval_s_off;
    }
    gtw_interval_m(value) {
        if (value !== undefined) {
            this._gtw_interval_m = value;
        }
        return this._gtw_interval_m;
    }
    gtw_workday_schedule(value) {
        if (value !== undefined) {
            this._gtw_workday_schedule = value;
        }
        return this._gtw_workday_schedule;
    }
    gtw_weekend_schedule(value) {
        if (value !== undefined) {
            this._gtw_weekend_schedule = value;
        }
        return this._gtw_weekend_schedule;
    }
    gtw_ten_schedule(value) {
        if (value !== undefined) {
            this._gtw_ten_schedule = value;
        }
        return this._gtw_ten_schedule;
    }
    gtw_gvs(value) {
        if (value !== undefined) {
            this._gtw_gvs = value;
        }
        return this._gtw_gvs;
    }
    gtw_thermostat_set(value) {
        if (value !== undefined) {
            this._gtw_thermostat_set = value;
        }
        return this._gtw_thermostat_set;
    }
    gtw_rele_max(value) {
        if (value !== undefined) {
            this._gtw_rele_max = value;
        }
        return this._gtw_rele_max;
    }
    gtw_t_gvs(value) {
        if (value !== undefined) {
            this._gtw_t_gvs = value;
        }
        return this._gtw_t_gvs;
    }
    gtw_t_water_max(value) {
        if (value !== undefined) {
            this._gtw_t_water_max = value;
        }
        return this._gtw_t_water_max;
    }
    gtw_interval_g_on(value) {
        if (value !== undefined) {
            this._gtw_interval_g_on = value;
        }
        return this._gtw_interval_g_on;
    }
    gtw_interval_g_off(value) {
        if (value !== undefined) {
            this._gtw_interval_g_off = value;
        }
        return this._gtw_interval_g_off;
    }
    gtw_t_water_floor_set(value) {
        if (value !== undefined) {
            this._gtw_t_water_floor_set = value;
        }
        return this._gtw_t_water_floor_set;
    }
    graphs_config(value) {
        if (value !== undefined) {
            this._graphs_config = value;
        }
        return this._graphs_config;
    }
    global_freeze_state(value) {
        if (value !== undefined) {
            this._global_freeze_state = value;
        }
        return this._global_freeze_state;
    }
    elinje_state(value) {
        if (value !== undefined) {
            this._elinje_state = value;
        }
        return this._elinje_state;
    }
    autoscan_settings(value) {
        if (value !== undefined) {
            this._autoscan_settings = value;
        }
        return this._autoscan_settings;
    }
    sx_downloading_config(value) {
        if (value !== undefined) {
            this._sx_downloading_config = value;
        }
        return this._sx_downloading_config;
    }
    sx_uploading_config(value) {
        if (value !== undefined) {
            this._sx_uploading_config = value;
        }
        return this._sx_uploading_config;
    }
    thermostat_service_password(value) {
        if (value !== undefined) {
            this._thermostat_service_password = value;
        }
        return this._thermostat_service_password;
    }
    stationary_location(value) {
        if (value !== undefined) {
            this._stationary_location = value;
        }
        return this._stationary_location;
    }
    use_internet_weather_for_pza(value) {
        if (value !== undefined) {
            this._use_internet_weather_for_pza = value;
        }
        return this._use_internet_weather_for_pza;
    }
    internet_weather(value) {
        if (value !== undefined) {
            this._internet_weather = value;
        }
        return this._internet_weather;
    }
    z3k_config(value) {
        if (value !== undefined) {
            this._z3k_config = value;
        }
        return this._z3k_config;
    }
    sim_in_device(value) {
        if (value !== undefined) {
            this._sim_in_device = value;
        }
        return this._sim_in_device;
    }
    cams(value) {
        if (value !== undefined) {
            this._cams = value;
        }
        return this._cams;
    }
    cams_show(value) {
        if (value !== undefined) {
            this._cams_show = value;
        }
        return this._cams_show;
    }
    maintenances(value) {
        if (value !== undefined) {
            this._maintenances = value;
        }
        return this._maintenances;
    }
    show_heating_tab(value) {
        if (value !== undefined) {
            this._show_heating_tab = value;
        }
        return this._show_heating_tab;
    }
    $wildcardListeners;
    notify(eventname, params) {
        params = params || []; // For IE8
        if (!(params instanceof Array))
            params = Array.prototype.slice.apply(params);
        if (this.$listeners && this.$listeners[eventname]) {
            const listeners = this.$listeners[eventname];
            for (let i = 0; i < listeners.length; i++)
                listeners[i].apply(this, params);
        }
        if (this.$wildcardListeners) {
            const wildcardParams = [this, eventname].concat(params);
            // for (var i in this.$wildcardListeners)
            for (let i = 0, len = this.$wildcardListeners.length; i < len; i++)
                this.$wildcardListeners[i].apply(this, wildcardParams);
        }
        // May be we will return something more interesting in future
        // for example, result of first/last listener
        return null;
    }
    notifier(eventname, bound_args) {
        return (props) => {
            let args;
            if (bound_args) {
                args = Array.prototype.slice.apply(bound_args);
            }
            else
                args = [];
            args.push(props);
            return this.notify(eventname, args);
        };
    }
    set(...args) {
        if (args.length == 1) {
            // @ts-ignore
            for (const i in args[0])
                if (this[i])
                    this[i](args[0][i]);
            // @ts-ignore
        }
        else if (this[args[0]])
            // @ts-ignore
            this[args[0]].apply(this, Array.prototype.slice.call(args, 1));
        return this;
    }
    bindWildcard(callback) {
        if (!this.$wildcardListeners)
            this.$wildcardListeners = [];
        this.$wildcardListeners.push(callback);
    }
    // @ts-ignore
    bind(...args) {
        if (args.length == 2) {
            const obj = {};
            // @ts-ignore
            obj[args[0]] = args[1];
            return this.bind(obj);
        }
        return new Binding(this, args[0]);
    }
    unbindWildcard(callback) {
        // for (var i in this.$wildcardListeners)
        for (let i = 0, len = this.$wildcardListeners.length; i < len; i++)
            if (this.$wildcardListeners[i] == callback)
                this.$wildcardListeners.splice(i, 1);
    }
}
function __mod__(a, b) {
    a = +a;
    b = +b;
    return ((a % b) + b) % b;
}
class Binding {
    obj;
    handlers;
    constructor(obj, handlers) {
        this.obj = obj;
        this.handlers = handlers;
        if (!obj.$listeners)
            obj.$listeners = {};
        for (const i in this.handlers) {
            if (obj.$listeners.hasOwnProperty(i))
                obj.$listeners[i].push(this.handlers[i]);
            else
                obj.$listeners[i] = [this.handlers[i]];
        }
    }
    unbind() {
        // for (var i in this.handlers)
        //     this.unbind(i, this.handlers[i]);
        delete this.obj;
        delete this.handlers;
    }
}
// .implement(Class.EventSource)
// .implement(
//     Class.Properties({
//         id: {value: -1},
//
//         serial: {event: true},
//         name: {event: true},
//         color: {event: true},
//         timezone: {
//             event: true,
//             set(value) {
//                 this._timezone = value;
//                 this.notify('access');
//             },
//         },
//
//         is_active: {event: true},
//
//         hardware_type: {event: true},
//         device_type: {event: true},
//
//         capabilities: {
//             event: true,
//
//             get() {
//                 return this._capabilities || [];
//             },
//         },
//
//         firmware_version: {
//             event: true,
//
//             set(value) {
//                 this._firmware_version = value;
//                 return this.notify('firmware_upgrade_available');
//             },
//         },
//
//         firmware_upgrade_available: {
//             event: 'firmware_upgrade_available',
//             get() {
//                 if (this.has_thermostat_service_password()) return false;
//
//                 const my = this._firmware_version;
//                 const last = this.last_firmware_version();
//
//                 if (my == null || last == null) return false;
//
//                 return my[0] < last[0] || (my[0] === last[0] && my[1] < last[1]);
//             },
//         },
//
//         online: {
//             value: false,
//             event: true,
//
//             set(value) {
//                 let prev;
//                 [prev, this._online] = [this._online, value];
//
//                 if (this._online) this.just_installed_firmware(false);
//                 else {
//                     // @_resetIOPorts()
//
//                     if (prev) this.last_connect_time(new Date());
//                 }
//             },
//         },
//
//         temperature_conf: {event: true},
//         temperature: {event: true},
//
//         gps_state: {event: true},
//         gsm_state: {event: true},
//         balance: {
//             event: true,
//             set(value) {
//                 // FIXME: The server sends {event: 'updated', balance: {value: 'xxx'}} events for the
//                 // FIXME: sake of the old mobile app. Following code is needed to make these events
//                 // FIXME: to merge into existing `balance` setting value instead of overwriting it.
//                 // FIXME: Remove this when the old mobile app will reach end-of-life. (tag: old-app-balance)
//                 this._balance = {
//                     ...(this._balance != null ? this._balance : {}),
//                     ...(value != null ? value : {}),
//                 };
//             },
//         },
//
//         auto_ignition: {
//             event: true,
//             set(value) {
//                 this._auto_ignition = value;
//
//                 if (this._auto_ignition_timer) {
//                     clearInterval(this._auto_ignition_timer);
//                     this._auto_ignition_timer = null;
//                 }
//
//                 if (value?.until > new Date().getTime() / 1e3) {
//                     const update = () => {
//                         const now = parseInt(new Date().getTime() / 1e3, 10);
//                         this.auto_ignition_timeout(
//                             parseInt(this._auto_ignition.until - now, 10)
//                         );
//                         if (this.auto_ignition_timeout() <= 0) {
//                             clearInterval(this._auto_ignition_timer);
//                             this._auto_ignition_timer = null;
//                         }
//                     };
//
//                     this._auto_ignition_timer = setInterval(update, 1000);
//                     update();
//                 } else this.auto_ignition_timeout(null);
//             },
//         },
//
//         auto_ignition_timeout: {event: true},
//
//         voltage: {event: true},
//         power_source: {event: true},
//
//         current_ecu_errors: {event: true},
//         saved_ecu_errors: {event: true},
//
//         suggest_firmware_upgrade: {event: true},
//
//         guard_state: {event: true},
//
//         filetransfers: {event: true},
//
//         just_installed_firmware: {
//             value: false,
//             event: true,
//         },
//
//         fuel_consumption: {event: true},
//
//         trusted_phones: {
//             event: 'trusted_phones',
//             set(value) {
//                 if (typeof value === 'string') {
//                     this._trusted_phones = $.map(value.split(','), (s) => s.trim());
//
//                     if (this._trusted_phones[0] === '') this._trusted_phones = [];
//                 } else this._trusted_phones = value;
//             },
//         },
//
//         accel_params: {event: true},
//
//         auto_ignition_duration: {event: true},
//         auto_ignition_params: {event: true},
//         auto_ignition_schedule: {event: true},
//
//         last_receive_time_relative: {
//             set(value) {
//                 if (value)
//                     this.last_connect_time(
//                         new Date(new Date().getTime() - value * 1000)
//                     );
//             },
//         },
//         last_connect_time: {event: true},
//
//         gps_relevance_relative: {
//             set(value) {
//                 if (value != null)
//                     this.gps_relevance_absolute(
//                         new Date(new Date().getTime() - value * 1000)
//                     );
//             },
//         },
//         gps_relevance_absolute: {
//             event: 'gps_relevance',
//         },
//
//         doors: {event: true},
//         door_1: {event: true},
//         door_2: {event: true},
//         door_3: {event: true},
//         door_4: {event: true},
//
//         hood_trunk: {event: true},
//         hood: {event: true},
//         trunk: {event: true},
//
//         engine_state: {event: true},
//         engine_block: {event: true},
//         siren: {event: true},
//         webasto: {event: true},
//
//         notifications: {event: true},
//         server_notifications: {},
//
//         autoguard: {event: true},
//
//         radiosilence: {event: true},
//         radiosilence_planned: {event: true},
//
//         thermometers: {event: true},
//
//         thermometers_reset_in_progress: {
//             event: true,
//
//             set(value) {
//                 // this._thermometers_reset_in_progress = !!value;
//
//                 if (value) {
//                     this._thermrestimer = setTimeout(() => {
//                         return this.thermometers_reset_in_progress(false);
//                     }, 120 * 1000);
//                 } else {
//                     if (this._thermrestimer) clearTimeout(this._thermrestimer);
//                     this._thermrestimer = null;
//                 }
//
//                 this.notify('thermometers');
//             },
//         },
//
//         tempschedule: {event: true},
//         tempschedule_multi: {event: true},
//
//         thermostat_mode: {event: true},
//         thermostat_mode_multi: {event: true},
//         thermostat_gate: {event: true},
//         thermostat_gate_multi: {event: true},
//         thermostat_gate_available: {
//             get() {
//                 const inputconf = this.thermostat_inputconfig();
//                 if (inputconf?.[1] === 'gate' || inputconf?.[2] === 'gate')
//                     return true;
//                 if (this.ot_enabled() && this.ot_gate_enabled()) return true;
//                 return false;
//             },
//         },
//
//         thermostat_mode_temps: {event: true},
//         thermostat_mode_temps_multi: {event: true},
//         temperature_alarm: {event: true},
//
//         thermostat_ext_mode: {event: true},
//         thermostat_ext_modes_config: {event: true},
//         thermostat_ext_modes_advanced: {},
//         thermostat_target_temps: {event: true},
//         thermostat_zones_settings: {event: true},
//         ot_zones_count: {event: true},
//         thermostat_temps_limits: {event: true},
//
//         notes: {event: true},
//
//         thermostat_hysteresis: {event: true},
//         thermostat_error_input_polarity: {event: true},
//
//         // This IO port doesn't updates its value when camera is connected or disconnected
//         // But comparsion with null might be used to check if device supports camera
//         camera_available: {event: true},
//
//         camera_count: {event: true},
//
//         tracker_mode: {event: true},
//
//         thermostat_inputconfig: {
//             event: true,
//
//             set(value) {
//                 this._thermostat_inputconfig = value;
//                 this.notify('capabilities');
//                 this.notify('thermostat_gate_available');
//             },
//         },
//         thermostat_enable_guard: {event: true},
//
//         thermostat_relay_mode: {event: true},
//
//         ztc110_inputconfig: {event: true},
//         ztc110_guard_polarity: {event: true},
//
//         zta110_inputconfig: {event: true},
//         zta110_outputconfig: {event: true},
//
//         last_guard_event: {event: true},
//
//         last_boiler_state: {event: true},
//
//         webasto_timeout: {event: true},
//
//         thermostat_enabled: {event: true},
//
//         ot_enabled: {event: true},
//         ot_mode: {},
//         ot_save_params: {},
//         ot_config: {event: true},
//         ot_show_dhw_control: {event: true},
//         ot_min_wp: {},
//         ot_max_ml: {},
//         ot_min_setpoint: {},
//         ot_max_setpoint: {},
//         ot_dhw_setpoint: {},
//         ot_boiler_type: {},
//         ot_gate_enabled: {
//             set(value) {
//                 this._ot_gate_enabled = value;
//                 this.notify('thermostat_gate_available');
//             },
//         },
//
//         rf_status: {
//             event: true,
//
//             set(value) {
//                 const rf = {};
//                 for (const k of Object.keys(value || {}))
//                     rf[k.replace(/^s_/, '')] = value[k];
//
//                 this._rf_status = rf;
//             },
//         },
//
//         tempstep: {
//             value: 1,
//             event: true,
//
//             set(value) {
//                 this._tempstep = value != null ? value : 1;
//             },
//         },
//
//         __temporary_thermometer_names: {event: true},
//
//         wifi_credentials: {event: true},
//
//         ecu_diagnostics_enabled: {event: true},
//         ecu_diagnostics_active: {event: true},
//
//         battery_percent: {event: true},
//
//         voicesiren_soundpack: {event: true},
//         siren_loudness: {},
//
//         handsfree: {},
//
//         ztcconfig_autostart: {},
//         ztcconfig_locking: {},
//         ztcconfig_battery: {},
//         ztcconfig_siren: {},
//         ztc_savestate: {},
//
//         gsm_roaming: {},
//
//         service_password_set: {},
//
//         boiler_info: {},
//
//         pza: {},
//         pza_max_delta: {},
//
//         boiler_delay: {},
//
//         user_id: {},
//         owner_username: {},
//         access: {
//             event: true,
//             set(access) {
//                 this._access = access;
//                 this._reschedule_access_timeouts();
//                 if (!this._called_from_update) this.update();
//             },
//         },
//
//         l1000_config: {event: true},
//
//         custom_controls: {event: true},
//         custom_controls_state: {event: true},
//         custom_controls_schedule: {},
//         debug_text_messages_regexp: {event: true},
//
//         // GTW settings
//         gtw_boiler_version: {event: true},
//         gtw_mode: {event: true},
//         gtw_heat: {event: true},
//         gtw_service_mode: {event: true},
//
//         gtw_fail: {event: true},
//         gtw_fail_countdown: {event: true},
//
//         gtw_ten_count: {event: true},
//         gtw_ten_max: {event: true},
//
//         gtw_sensors_valid: {event: true},
//         gtw_t_air_int_sensor: {event: true},
//         gtw_t_air_ext_sensor: {event: true},
//         gtw_t_water_sensor: {event: true},
//         gtw_t_water: {event: true},
//         gtw_t_air: {event: true},
//         gtw_t_air_comfort: {event: true},
//         gtw_t_air_econom: {event: true},
//         gtw_t_air_pza: {event: true},
//         gtw_t_water_set_disp: {event: true},
//         gtw_t_air_set_disp: {event: true},
//
//         gtw_p_water: {event: true},
//
//         gtw_thermostat_air: {event: true},
//         gtw_thermostat_gvs: {event: true},
//
//         gtw_time: {event: true},
//         gtw_temporary_end: {event: true},
//
//         gtw_nominal_power: {event: true},
//
//         gtw_interval_s_on: {event: true},
//         gtw_interval_s_off: {event: true},
//         gtw_interval_m: {event: true},
//
//         gtw_workday_schedule: {event: true},
//         gtw_weekend_schedule: {event: true},
//         gtw_ten_schedule: {},
//         gtw_gvs: {event: true},
//         gtw_thermostat_set: {event: true},
//
//         gtw_rele_max: {},
//         gtw_t_gvs: {},
//         gtw_t_water_max: {},
//         gtw_interval_g_on: {},
//         gtw_interval_g_off: {},
//         gtw_t_water_floor_set: {},
//
//         graphs_config: {},
//
//         global_freeze_state: {event: true},
//         elinje_state: {event: true},
//
//         autoscan_settings: {event: true},
//
//         sx_downloading_config: {event: true},
//         sx_uploading_config: {event: true},
//
//         thermostat_service_password: {},
//         stationary_location: {event: true},
//
//         use_internet_weather_for_pza: {event: true},
//         internet_weather: {event: true},
//
//         z3k_config: {event: true},
//
//         sim_in_device: {event: true},
//
//         cams: {event: true},
//         cams_show: {event: true},
//         maintenances: {event: true},
//         show_heating_tab: {event: true},
//     })
// );
